import { useCallback } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useToastStore } from '@/store';
import copyText from '@/constants/utils/copy_text';
import { formatAgentChatRegistry, getAgentChatUrl, isPrivateAgent } from '@/utils/agent_share';

export default function useCopyAgentLink() {
  const { t } = useTranslation();
  const addToast = useToastStore((state) => state.actions.addToast);

  const copyAgentLink = useCallback(async (agentOrId) => {
    const url = getAgentChatUrl(agentOrId);
    if (!url) return false;
    try {
      await copyText(url);
      addToast(
        isPrivateAgent(agentOrId)
          ? t('pages.agents.privateLinkCopied')
          : t('modals.share.linkCopied'),
        isPrivateAgent(agentOrId) ? 'default' : 'success',
      );
      return true;
    } catch {
      addToast(t('modals.share.failedToCopy'), 'error');
      return false;
    }
  }, [addToast, t]);

  const copyAgentRegistry = useCallback(async (agents) => {
    const text = formatAgentChatRegistry(agents);
    if (!text) return false;
    try {
      await copyText(text);
      const count = text.split('\n').length;
      addToast(
        t('pages.agents.linksCopied').replace('%COUNT%', String(count)),
        'success',
      );
      return true;
    } catch {
      addToast(t('modals.share.failedToCopy'), 'error');
      return false;
    }
  }, [addToast, t]);

  return { copyAgentLink, copyAgentRegistry };
}
